import React from 'react'
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import exportValue from '../../apiconfig'
import Moment from 'react-moment';
import ReactStarsRating from 'react-awesome-stars-rating';
import '../../components/loader.css';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import ReactLoading from 'react-loading';





const Shipment_detail = () => {
  const [value, setValue] = React.useState('1')
  const { invoice_id } = useParams();
  const [state, setState] = React.useState({ shipmentDetail: { sender: {}, receiver: {}, items: [] }, isLoading: true, detailFound: false, parcel_count: 0 })
  const [addstate, setaddState] = React.useState({ mode: "", transaction_id: "" })
  const [editstate, seteditState] = React.useState({ show: false, shipment_id: "", paid_to: "" })
  const [dimensionState, setdimensionState] = React.useState({ companyDetail: [] })
  const [failedstate, setfailed] = React.useState({ failed: "" })
  const [trackingstate, setTrackingState] = React.useState({ track: {}, isLoading: true })
  const [stateship, setStateship] = React.useState({ shipmentDetail: { sender: {}, receiver: {}, items: [] }, isLoading: true, detailFound: false, parcel_count: 0 })
  console.log("stateship == " , stateship)
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [manualstatus, setmanualstatus] = React.useState('');
  const [mailstate, setmailstate] = React.useState({ subject: "", content: "" });
  const [showEditConsignee, setShowEditConsignee] = React.useState(false);
  const [selectedConsigneeField, setSelectedConsigneeField] = React.useState('');
  const [editedConsignee, setEditedConsignee] = React.useState({
    name: '',
    address: '',
    mobile: '',
    payment_mode: '',
    cod_amount: ''
  });
  const [isUpdatingConsignee, setIsUpdatingConsignee] = React.useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
      homeSection.classList.toggle('sidebar-closed');
    }
  };
  const dimension_detail = () => {
    let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/company_info_api`;
    let sendData = {};

    axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
      setdimensionState({ ...dimensionState, companyDetail: res.data.companyDetail });
      console.log("rnmmmmm", res);
    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      console.log("----error:   ", e);
    })
  }
  React.useEffect(() => {
    dimension_detail();
    ShipmentDetail()
    status_update()
    shipment_tracking()

  }, [])
  const status_update = () => {

    let full_api = exportValue.apiUrl + '/shipment/shipment_tracking';
    let sendData = { trackingNumber: invoice_id };
    console.log("senddata", sendData)

    axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {

      console.log("res", res)
      //  if(res.data.message=="success"){

      //      Swal.fire(
      //          'Success!',
      //          ' Status Updated Successfully !',
      //          'success'
      //        )
      //       //  window.location.reload(false);
      //  }


      //  else{
      //      Swal.fire(
      //          'Unsuccess!',
      //          'Something Went Wrong !',
      //          'success'
      //        )
      //        window.location.reload(false);

      //  }
    })

  }

  const ShipmentDetail = () => {

    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/shipment_detail`;
    let sendData = { shipment_id: invoice_id };
    console.log("bb", sendData);
    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
      console.log("res -> ", res);


      setState({ ...state, shipmentDetail: res.data.output[0], parcel_count: res.data.output[0].items.length, isLoading: false })


    }).catch((e) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',

      })
      console.log("----error:   ", e);
    });
  };
  const shipment_failed = () => {

    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/check_failed_shipments`;
    let sendData = { shipment_id: invoice_id };
    console.log("bb", sendData);
    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
      console.log("res -> ", res);


      setfailed({ ...failedstate, failed: res.data.output })


    }).catch((e) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',

      })
      console.log("----error:   ", e);
    });
  };
  React.useEffect(() => {
    ShipmentDetail();
    shipment_failed();

  }, [])

  const nameFormat = (name) => {

    if (name) {
      let nameArray = name.split(" ");
      // console.log("nameArray  ",nameArray);
      if (nameArray.length > 1) {
        let n1 = nameArray[0].substring(0, 1).toUpperCase();
        let n2 = nameArray[1].substring(0, 1).toUpperCase();
        name = n1 + n2;
      } else {
        name = nameArray[0].substring(0, 2).toUpperCase();
      }
    } else {
      name = "NO";
    }
    return name;
  }


  //  const SenderAddress = () =>{
  //   if(state.shipmentDetail.items.length > 0){
  //     console.log("==>  ",state.shipmentDetail.items);
  //     return state.shipmentDetail.items.reduce((previousValue, currentValue) =>{
  //       return previousValue.item_weight + currentValue.item_weight},{item_weight:0}) 
  //   }else {
  //     return 0
  //   }
  //  } 
  const shipment_tracking = () => {

    let full_api = exportValue.apiUrl + `/shipment/shipment_tracking`;
    let sendData = { trackingNumber: invoice_id };
    // console.log("sendData",sendData)

    axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
      if (res.data.status == 200) {
        console.log("2000 ")
        setTrackingState({ ...trackingstate, track: res.data.output, isLoading: false })
        // console.log("res",trackingstate.track)
        setStateship({ ...stateship, shipmentDetail: res.data.ship_detail, isLoading: false })
      }
      else {
        console.log("5000")
        setTrackingState({ ...trackingstate, track: res.data.output, isLoading: false })
        // console.log("res",trackingstate.track)
        setStateship({ ...stateship, shipmentDetail: res.data.ship_detail, isLoading: false })
      }


    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }


  const changeStatus = (e) => {
    setmanualstatus(e.target.value)
  }

  const submitchangeStatus = () => {

    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/manual_change_status`;
    let sendData = { status: manualstatus, shipment_id: invoice_id };
    axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
      if (res.data.status == true) {
        Swal.fire({
          icon: 'success',
          title: 'Good job...',
          text: res.data.message,
        })
        ShipmentDetail()
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: res.data.message,
        })
      }


    }).catch((e) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something Went Wrong',
      })
    })
  }

  const mailChange = (e) => {
    setmailstate({ ...mailstate, [e.target.name]: e.target.value })
  }


  const submitsendmail = (shipment) => {
    if (mailstate.content != "" && mailstate.subject) {
      let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/send_mail_to_carrier`;
      let sendData = { shipment: shipment, content: mailstate.content, subject: mailstate.subject };
      axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
        if (res.data.status == true) {
          Swal.fire({
            icon: 'success',
            title: 'Good job...',
            text: res.data.message,
          })
          setmailstate({ content: "", subject: "" })
          ShipmentDetail()
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: res.data.message,
          })
        }


      }).catch((e) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something Went Wrong',
        })
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Fill Details',
      })
    }
  }
  const getCODVerificationBadge = (status) => {
    switch (status) {
      case 0:
        return <span className="badge bg-secondary">OFF</span>;
      case 1:
        return <span className="badge bg-success">Prepaid</span>;
      case 2:
        return <span className="badge bg-warning ">Pending</span>;
      case 3:
        return <span className="badge bg-success">Verified</span>;
      case 4:
        return <span className="badge bg-danger">Refused</span>;
      case 5:
        return <span className="badge bg-warning ">Override-Pending</span>;
      case 6:
        return <span className="badge bg-danger">Override-Refused</span>;
      case 7:
        return <span className="badge bg-secondary ">OFF</span>;
      default:
        return <span className="badge bg-secondary">OFF</span>;
    }
  };

  const generateCurl = (shipment) => {
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/generate_curl`;
    let sendData = { shipment };

    axios.post(full_api, sendData, { headers: exportValue.headers })
      .then(res => {
        if (res.data.status === true && res.data.logs.length > 0) {
          // Find the first log of type "request"
          const log = res.data.logs.find(log => log.message?.type === "request");

          if (log) {
            const options = log.message.options ? log.message.options : log.message.config;
            console.log("Request Options:", options);

            // 👉 You can now display this as you like:
            // - In a modal
            // - In a code block
            // - Export to cURL
            // Example: show in alert (for testing only)
            Swal.fire({
              title: 'API Request (cURL)',
              html: `
                <pre style="text-align:left;">${JSON.stringify(options, null, 2)}</pre>
              `,
              width: '60%',
              customClass: {
                popup: 'swal-wide',
              },
            });

          } else {
            Swal.fire({
              icon: 'info',
              title: 'No Request Log Found',
              text: 'No matching request log entry found for this shipment.',
            });
          }

        } else {
          Swal.fire({
            icon: 'info',
            title: 'No Logs Found',
            text: 'No logs were found for this shipment.',
          });
        }
      })
      .catch((e) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong while fetching the curl log.',
        });
      });
  };


  const handleConsigneeUpdate = async () => {
    if (!selectedConsigneeField || !editedConsignee[selectedConsigneeField]) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select a field and enter a value',
      });
      return;
    }
  
    // Determine the actual payment mode to validate and send
    let actualPaymentMode = editedConsignee.payment_mode;
    let requiresCodAmount = false;
  
    // If UI shows COD as locked (editedConsignee.payment_mode === 'prepaid'), 
    // it means we're actually changing to COD
    if (selectedConsigneeField === 'payment_mode' && editedConsignee.payment_mode === 'prepaid') {
      actualPaymentMode = 'cod';
      requiresCodAmount = true;
    }
    else if(selectedConsigneeField === 'payment_mode' && editedConsignee.payment_mode === 'cod'){
      actualPaymentMode = 'prepaid';
      requiresCodAmount = false;
    }
  
    // Validate COD amount if required
    if (requiresCodAmount && !editedConsignee.cod_amount) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please enter COD amount when selecting COD payment mode',
      });
      return;
    }
  
    setIsUpdatingConsignee(true);
  
    try {
      let payload = {
        shipment: state.shipmentDetail,
        field: selectedConsigneeField,
        value: selectedConsigneeField === 'payment_mode' ? actualPaymentMode : editedConsignee[selectedConsigneeField],
      };
  
      // Special case: if updating payment_mode
      if (selectedConsigneeField === 'payment_mode') {
        payload = {
          ...payload,
          payment_mode: actualPaymentMode,
          cod_amount: actualPaymentMode === 'cod' ? editedConsignee.cod_amount : null,
        };
      }
  
      const response = await axios.post(
        `${exportValue.host}/${exportValue.version}/${exportValue.api}/update_receiver_details`,
        payload,
        { headers: exportValue.headers }
      );
  
      if (response.data.success) {
        // Update local state with actual values
        const updatedSub = {
          ...state.shipmentDetail,
          receiver: {
            ...state.shipmentDetail.receiver,
            [selectedConsigneeField]: selectedConsigneeField === 'payment_mode' ? actualPaymentMode : editedConsignee[selectedConsigneeField],
          },
          payment_mode: actualPaymentMode,
          cod_amount: actualPaymentMode === 'cod' ? editedConsignee.cod_amount : null,
        };
  
        setState({ ...state, shipmentDetail: updatedSub, isLoading: false });
        setSelectedConsigneeField('');
        setShowEditConsignee(false);
  
        Swal.fire({
          icon: 'success',
          title: 'Good job...',
          text: 'Consignee details updated successfully!',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops..',
          text: response.data.message || 'Failed to update consignee details',
        });
      }
    } catch (error) {
      console.error('Error updating consignee:', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops..',
        text: 'An error occurred while updating consignee details',
      });
    } finally {
      setIsUpdatingConsignee(false);
    }
  };

  React.useEffect(() => {
    if (state.shipmentDetail && state.shipmentDetail.receiver) {
      setEditedConsignee({
        name: state.shipmentDetail.receiver.name,
        address: state.shipmentDetail.receiver.address,
        mobile: state.shipmentDetail.receiver.mobile,
        payment_mode: state.shipmentDetail.payment_mode || '',
        cod_amount: state.shipmentDetail.cod_amount || ''
      });
    }
  }, [showEditConsignee]);
 
  return (
    <div>

      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <section class="home-section">
        <Sub_header />




        <section>
          <div class="row my-3">
            <div class="col-12 col-md">
              <div class="d-flex">
                <div class="back_btn_wrap">
                  <a href="javascript:window.history.back();" class="back_btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="corner-up-left" class="lucide lucide-corner-up-left"><polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path></svg>
                  </a>
                </div>
                <div class="">
                  <h2><small>Shipment #</small>{state.shipmentDetail.shipment_id}</h2>
                </div>


              </div>

            </div>
            {state.shipmentDetail.status != 7 ?
              <div class="col-12 col-md-4 text-end">
                <a href="#" data-bs-toggle="modal" data-bs-target="#shipment_mn_update" class="btn btn-info" data-bs-backdrop="false">Update Shipment Status</a>
                <a href="#" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#mail" data-bs-backdrop="false">Send Mail To Carrier</a>
              </div>
              : ""}
            <div class="modal" id="shipment_mn_update" data-bs-backdrop="false">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title">Manual Shipment Status Update</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                  </div>

                  <div class="modal-body">
                    <div class="row mb-3">
                      <div class="col-12 col-md-4">
                        <label for="email" class="form-label">New Status:</label>
                      </div>
                      <div class="col-12 col-md">
                        <select class="form-select" onChange={(e) => changeStatus(e)}>
                          <option value='1'>Pick Up Awaited</option>
                          <option value='9'>Picke Up Scheduled</option>
                          <option value='3'>In Transit</option>
                          <option value='4'>Out For Delivery</option>
                          <option value='2'>Picked Up</option>
                          <option value='17'>Picked Failed</option>
                          <option value='5'>Delivered</option>
                          <option value='10'>RTO</option>
                          <option value='19'>RTO In Transit</option>

                          <option value='16'>RTO Delivered</option>
                          <option value='6'>Cancel</option>
                          <option value='8'>NDR</option>




                        </select>
                      </div>
                    </div>
                    <small class="text-info">Updating the shipment status manually will only change the current status of the shipment. This update will not reflect in the tracking history, as the tracking history is exclusively managed and fetched through the API.</small>
                  </div>

                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" onClick={(e) => submitchangeStatus(e)}>Update Status</button>
                  </div>

                </div>
              </div>
            </div>


            <div class="modal" id="mail" data-bs-backdrop="false">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title">Send Mail</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                  </div>

                  <div class="modal-body">
                    <div class="row mb-3">
                      <div class="col-12 col-md-12">
                        <label>Awb Number</label>
                        <input className='form-control bg-grey' value={state.shipmentDetail.carrier_tracking_number} readOnly />
                      </div>
                      <div class="col-12 col-md-12 mt-2">
                        <label>Subject</label>
                        <input className='form-control' onChange={(e) => mailChange(e)} name='subject' />
                      </div>
                      <div class="col-12 col-md-12 mt-2">
                        <label>Content</label>
                        <textarea className='form-control' onChange={(e) => mailChange(e)} name='content' />
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" onClick={(e) => submitsendmail(state.shipmentDetail)}>Submit</button>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-12 col-md-2 text-end shipm_tablew">
              {/* <span class="status pickedup"> <i class="fa fa-check" aria-hidden="true"></i> Pickedup</span> */}
              {state.shipmentDetail.status == 0 ? <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i> Pending</span> : state.shipmentDetail.status == 10 ? <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i> RTO</span> : state.shipmentDetail.status == 19 ? <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i> RTO In Transit</span> : state.shipmentDetail.status == 16 ? <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i> RTO Delivered</span> : state.shipmentDetail.status == 15 ? <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i>Booked</span> : state.shipmentDetail.status == 1 ? <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i> Pickup Awaited</span> : state.shipmentDetail.status == 2 ? <span class="status pickedup"> <i class="fa fa-check" aria-hidden="true"></i> Picked Up</span> : state.shipmentDetail.status == 3 ? <span class="status in_transit"> <i class="fa fa-truck" aria-hidden="true"></i> In Transit</span> : state.shipmentDetail.status == 4 ? <span class="status out_f_deli"> <i class="fa fa-plane" aria-hidden="true"></i> Out for Delivery</span> : state.shipmentDetail.status == 5 ? <span class="status delivered"> <i class="fa fa-check-square-o" aria-hidden="true"></i> Delivered</span> : state.shipmentDetail.status == 17 ? <span class="status delivered"> <i class="fa fa-check-square-o" aria-hidden="true"></i> Pickup Failed</span> : state.shipmentDetail.status == 6 ? <span class="status cancelled"> <i class="fa fa-ban" aria-hidden="true"></i> Cancelled</span> : state.shipmentDetail.status == 7 ? <span class="status failed"> <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Failed</span> : state.shipmentDetail.status == 8 ? <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i> NDR</span> : state.shipmentDetail.status == 20 ? <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i> Lost</span> : state.shipmentDetail.status == 9 ? <>   <span class="status pickup_sechdls"> <i class="fa fa-calendar-o" aria-hidden="true"></i> Pickup Scheduled</span><br /><br />
                {state.shipmentDetail.pickup_date != undefined && state.shipmentDetail.pickup_date != "" ? <small>on {state.shipmentDetail.pickup_date != undefined ? state.shipmentDetail.pickup_date : ""} at {state.shipmentDetail.pickup_time != undefined ? state.shipmentDetail.pickup_time : ""}</small> : ""} </> : <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i> Not Available</span>}
            </div>
          </div>
          {failedstate.failed != "" ?
            <div class="alert alert-danger text-center" role="alert">
              Shipment Failed Due to "{failedstate.failed}"
            </div> : ""}


          <div class="">
            <div class="row mt-3 order_box_cont">
              <div class="col-12 col-md-8 ">




                <div class="card border-0 mb-3">
                  <div class="card-body">
                    <div class="d-flex ">
                      <div class="border-end pe-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="truck" class="lucide lucide-truck"><path d="M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11"></path><path d="M14 9h4l4 4v4c0 .6-.4 1-1 1h-2"></path><circle cx="7" cy="18" r="2"></circle><path d="M15 18H9"></path><circle cx="17" cy="18" r="2"></circle></svg>
                      </div>
                      <div class="ps-3 ">
                        <h6>Shipping Details</h6>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="col-12 col-md-4 mb-2">
                        <img src="./assets/img/carriers_logo/fedex.svg" alt="" class="img-fluid" title="Fedex Inc." />
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Order No.</small>
                        <p><strong><a href="">{state.shipmentDetail.order_number}</a></strong></p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Order on</small>
                        <p><a href=""><Moment format="MMM DD YYYY hh:mm">
                          {new Date(state.shipmentDetail.created * 1000)}
                        </Moment> </a></p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Shipping Courier</small>
                        <p>{state.shipmentDetail.service_provider}</p>
                      </div>
                      {/* <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Shipping Courier AWB No.</small>
                        <p><a href="">{state.shipmentDetail.carrier_tracking_number ? state.shipmentDetail.carrier_tracking_number : ""}</a></p>
                      </div> */}
                      {state.shipmentDetail.carrier_type == "B2B" ?
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Shipping Courier LR No.</small>
                          <p><a href="">{state.shipmentDetail.lrnum ? state.shipmentDetail.lrnum : ""}</a></p>
                        </div>
                        :
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Shipping Courier AWB No.</small>
                          <p><a href="">{state.shipmentDetail.carrier_tracking_number ? state.shipmentDetail.carrier_tracking_number : ""}</a></p>
                        </div>
                      }
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Shipping Courier Service</small>
                        <p>{state.shipmentDetail.service_provider ? state.shipmentDetail.service_provider : ""}</p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Order Type</small>
                        <p>{state.shipmentDetail.mode}</p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Shipment Type</small>
                        <p>Forward</p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Courier Rule Applied</small>
                        <p>N/A</p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Zone Name</small>
                        <p>{state.shipmentDetail.zone_name ? state.shipmentDetail.zone_name : ""}</p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                                        <small class="text-muted">COD Verification</small>
                                        <p>  {getCODVerificationBadge(state.shipmentDetail.cod_verification_status)}</p>
                                      </div>
                      <div class="col-12 col-md-4 mb-2">

                        <a className='btn btn-primary' onClick={(e) => generateCurl(state.shipmentDetail)}>Generate Curl</a>
                      </div>
                      {state.shipmentDetail.status==4?
                      <>
                      <div class="col-12 col-md-4 mb-2">
                      <small class="text-muted">Rider Name</small>
                        <p>{state.shipmentDetail.rider_name ? state.shipmentDetail.rider_name : ""}</p>
                     </div>
                     <div class="col-12 col-md-4 mb-2">
                      <small class="text-muted">Rider Mobile</small>
                        <p>{state.shipmentDetail.rider_mobile ? state.shipmentDetail.rider_mobile : ""}</p>
                     </div>
                     </>
                     :""}
                    </div>
                  </div>
                </div>

                <div class="card border-0  mb-3">
                  <div class="card-body">
                    <div class="d-flex ">
                      <div class="border-end pe-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-open" class="lucide lucide-package-open"><path d="M20.91 8.84 8.56 2.23a1.93 1.93 0 0 0-1.81 0L3.1 4.13a2.12 2.12 0 0 0-.05 3.69l12.22 6.93a2 2 0 0 0 1.94 0L21 12.51a2.12 2.12 0 0 0-.09-3.67Z"></path><path d="m3.09 8.84 12.35-6.61a1.93 1.93 0 0 1 1.81 0l3.65 1.9a2.12 2.12 0 0 1 .1 3.69L8.73 14.75a2 2 0 0 1-1.94 0L3 12.51a2.12 2.12 0 0 1 .09-3.67Z"></path><line x1="12" x2="12" y1="22" y2="13"></line><path d="M20 13.5v3.37a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13.5"></path></svg>
                      </div>
                      <div class="ps-3 ">
                        <h6>Package Details</h6>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Initial Applicable Weight (in Kg)</small>
                        <p>{state.shipmentDetail.total_weight}KG</p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Dead Weight (in Kg)</small>
                        <p>{state.shipmentDetail.dead_weight}KG</p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Volumetric Weight (in kg)</small>
                        <p>{state.shipmentDetail.volumetric_weight ? state.shipmentDetail.volumetric_weight.toFixed(2) : ""}KG</p>
                      </div>
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Dimensions (in cm)</small>
                        <p>{state.shipmentDetail.height} x {state.shipmentDetail.width} x {state.shipmentDetail.length}</p>
                      </div>
                      {state.shipmentDetail.carrier_type == "B2B" ?
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Number of Boxes</small>
                          <p>{state.shipmentDetail.boxes.reduce((total, box) => total + (box.quantity || 0), 0)}</p>
                        </div>
                        : <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Number of Boxes</small>
                          <p>1</p>
                        </div>}

                      {state.shipmentDetail.carrier_type == "B2B" ?
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Chargeable Weight</small>
                          {state.shipmentDetail.b2b_discrepancy_weight ? <p>{Number(state.shipmentDetail.b2b_discrepancy_weight + state.shipmentDetail.total_weight).toFixed(2)} KG</p> : <p>{state.shipmentDetail.total_weight.toFixed(2)} KG</p>}
                        </div>
                        : <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Shipment value</small>
                          <p>₹ {state.shipmentDetail.items.reduce((total, sub) => total + parseFloat(sub.item_value), 0).toFixed(2)} </p>
                        </div>}
                      <div class="col-12 col-md-4 mb-2">
                        <small class="text-muted">Payment Mode</small>
                        <p>{state.shipmentDetail.payment_mode == "cod" ? `₹ ${state.shipmentDetail.cod_amount}` : ""} <span class="badge rounded-pill bg-warning">{state.shipmentDetail.payment_mode}</span></p>
                      </div>
                      {state.shipmentDetail.carrier_type == "B2B" ?
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted"> Pickup type </small>
                          <p>{state.shipmentDetail.self == true ? "Pickup" : "Self Drop"}</p>
                        </div>
                        : ""}
                      {state.shipmentDetail.carrier_type == "B2B" ?
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted"> Insurance type </small>
                          <p>{state.shipmentDetail.rv_insurance == true ? "Carrier Risk" : "Owner Risk"}</p>
                        </div>
                        : ""}
                    </div>
                  </div>
                </div>


                <div class="card border-0 mb-3">
                  <div class="card-body">
                    <div class="d-flex ">
                      <div class="border-end pe-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package" class="lucide lucide-package"><path d="m7.5 4.27 9 5.15"></path><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path><path d="m3.3 7 8.7 5 8.7-5"></path><path d="M12 22V12"></path></svg>
                      </div>
                      <div class="ps-3 ">
                        <h6>Shipment Details</h6>
                      </div>
                    </div>
                    <hr />
                    <div class="row">

                      <div class="col-12 col-md">
                        <h6>Ship From:</h6>
                        <small class="text-muted">Sender Name:</small>
                        <p>{state.shipmentDetail.sender.name}</p>
                        <small class="text-muted">Sender Address:</small>
                        <p>{state.shipmentDetail.sender.address}, {state.shipmentDetail.sender.city}, {state.shipmentDetail.sender.state} {state.shipmentDetail.sender.pincode}</p>
                        <small class="text-muted">Sender Email:</small>
                        <p>{state.shipmentDetail.sender.email}</p>
                        <small class="text-muted">Sender Mobile:</small>
                        <p>{state.shipmentDetail.sender.mobile}</p>
                      </div>
                      <div class="col-12 col-md">
                      <div className="d-flex justify-content-between align-items-center">
                      <h6>Ship To:</h6>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => setShowEditConsignee(!showEditConsignee)}
                      >
                        {showEditConsignee ? 'Cancel' : 'Edit'}
                      </button>
                    </div>
                    {showEditConsignee ? (
                      <div className="edit-consignee-form mb-3">
                        <div className="mb-2">
                          <label className="form-label">Select Field to Edit:</label>
                          <select
                            className="form-select mb-3"
                            value={selectedConsigneeField}
                            onChange={(e) => setSelectedConsigneeField(e.target.value)}
                          >
                            <option value="">Select field</option>
                            <option value="name">Name</option>
                            <option value="address">Address</option>
                            <option value="mobile">Mobile</option>
                            <option value="payment_mode">Payment Mode</option>
                          </select>
                        </div>

                        {selectedConsigneeField === 'name' && (
                          <div className="mb-2">
                            <label className="form-label">Receiver Name:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={editedConsignee.name}
                              onChange={(e) => setEditedConsignee({ ...editedConsignee, name: e.target.value })}
                            />
                          </div>
                        )}

                        {selectedConsigneeField === 'address' && (
                          <div className="mb-2">
                            <label className="form-label">Receiver Address:</label>
                            <textarea
                              className="form-control"
                              value={editedConsignee.address}
                              onChange={(e) => setEditedConsignee({ ...editedConsignee, address: e.target.value })}
                            />
                          </div>
                        )}

                        {selectedConsigneeField === 'mobile' && (
                          <div className="mb-2">
                            <label className="form-label">Receiver Mobile:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={editedConsignee.mobile}
                              onChange={(e) => setEditedConsignee({ ...editedConsignee, mobile: e.target.value })}
                            />
                          </div>
                        )}
                        
                        {selectedConsigneeField === 'payment_mode' && (
  <div className="mb-2">
    <label className="form-label">Payment Mode:</label>
    
    {/* If payment_mode is prepaid, show COD as locked */}
    {editedConsignee.payment_mode === 'prepaid' && (
      <select
        className="form-select"
        value="cod"
        disabled
      >
        <option value="cod">COD</option>
      </select>
    )}
    
    {/* If payment_mode is cod, show Prepaid as locked */}
    {editedConsignee.payment_mode === 'cod' && (
      <select
        className="form-select"
        value="prepaid"
        disabled
      >
        <option value="prepaid">Prepaid</option>
      </select>
    )}

    {/* Show COD amount field ONLY if payment_mode is prepaid (which shows COD as locked) */}
    {editedConsignee.payment_mode === 'prepaid' && (
      <div className="mt-2">
        <label className="form-label">COD Amount:</label>
        <input
          type="number"
          className="form-control"
          value={editedConsignee.cod_amount || ''}
          onChange={(e) =>
            setEditedConsignee({ ...editedConsignee, cod_amount: e.target.value })
          }
          placeholder="Enter COD amount"
        />
      </div>
    )}
  </div>
)}

                        {selectedConsigneeField && (
                         <button
                         className="btn btn-sm btn-success"
                         onClick={handleConsigneeUpdate}
                         disabled={
                           isUpdatingConsignee ||
                           !editedConsignee[selectedConsigneeField] ||
                           (selectedConsigneeField === 'payment_mode' &&
                             editedConsignee.payment_mode === 'prepaid' && // UI shows COD as locked
                             !editedConsignee.cod_amount)
                         }
                       >
                         {isUpdatingConsignee ? 'Updating...' : 'Update'}
                       </button>
                        )}
                      </div>
                    ) : (
                      <>
                        <small class="text-muted">Receiver Name:</small>
                        <p>{state.shipmentDetail.receiver.name}</p>
                        <small class="text-muted">Receiver Address:</small>
                        <p>{state.shipmentDetail.receiver.address}, {state.shipmentDetail.receiver.city}, {state.shipmentDetail.receiver.state} {state.shipmentDetail.receiver.pincode}</p>
                        <small class="text-muted">Receiver Email:</small>
                        <p>{state.shipmentDetail.receiver.email}</p>
                        <small class="text-muted">Receiver Mobile:</small>
                        <p>{state.shipmentDetail.receiver.mobile}</p>
                        </>
                       )}
                      </div>
                    </div>
                  </div>
                </div>

                {state.shipmentDetail.carrier_type == "B2B" ?
                  <div class="card border-0 mb-3">
                    <div class="card-body">
                      <div class="d-flex ">
                        <div class="border-end pe-3">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="shopping-basket" class="lucide lucide-shopping-basket"><path d="m15 11-1 9"></path><path d="m19 11-4-7"></path><path d="M2 11h20"></path><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path><path d="M4.5 15.5h15"></path><path d="m5 11 4-7"></path><path d="m9 11 1 9"></path></svg>
                        </div>
                        <div class="ps-3 ">
                          <h6>VAS Charges</h6>
                        </div>
                      </div>
                      <hr />
                      <div class="table-responsive ">
                        <table class="table ">
                          <thead>
                            <tr>
                              <th>Charge Type</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {state.shipmentDetail.vasChargesHistory ?
                              state.shipmentDetail.vasChargesHistory.map((sub) => (
                                <tr>

                                  <td>{sub.chargeType}</td>
                                  <td>{sub.amount}</td>
                                </tr>
                              )) : ""}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> : ""}

                {state.shipmentDetail.status != 7 ?
                  <div class="card border-0  mb-3">
                    <div class="card-body">
                      <div class="d-flex ">
                        <div class="border-end pe-3">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="dollar-sign" class="lucide lucide-dollar-sign"><line x1="12" x2="12" y1="2" y2="22"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                        </div>
                        <div class="ps-3 ">
                          <h6>Payment Details</h6>
                        </div>
                      </div>
                      <hr />

                      <div class="row">
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Transaction ID</small>
                          <p><a href="">{state.shipmentDetail.payment_transaction_id}</a></p>
                        </div>
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Payment Mode</small>
                          <p>Wallet</p>
                        </div>
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Total Paid Amount</small>
                          <p>₹ {state.shipmentDetail.total_amount}</p>
                        </div>
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Bill To (Customer)</small>
                          <p>{state.shipmentDetail.sender.name}</p>
                        </div>
                        <div class="col-12 col-md-4 mb-2">
                          <small class="text-muted">Customer JP ID</small>
                          <p><a >{state.shipmentDetail.jp_id?state.shipmentDetail.jp_id:""}</a></p>
                        </div>
                      </div>

                    </div>
                  </div>
                  : ""}
                {state.shipmentDetail.carrier_type == "B2B" ?
                  <div class="card border-0 mb-3">
                    <div class="card-body">
                      <div class="d-flex ">
                        <div class="border-end pe-3">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="shopping-basket" class="lucide lucide-shopping-basket"><path d="m15 11-1 9"></path><path d="m19 11-4-7"></path><path d="M2 11h20"></path><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path><path d="M4.5 15.5h15"></path><path d="m5 11 4-7"></path><path d="m9 11 1 9"></path></svg>
                        </div>
                        <div class="ps-3 ">
                          <h6>Boxes Details</h6>
                        </div>
                      </div>
                      <hr />
                      <div class="table-responsive ">
                        <table class="table ">
                          <thead>
                            <tr>
                              <th>Length</th>
                              <th>Width</th>
                              <th>Height</th>
                              <th>Weight</th>
                              <th>Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {state.shipmentDetail.boxes.map((sub) => (
                              <tr>

                                <td>{sub.box_length}</td>
                                <td>{sub.box_width}</td>
                                <td>{sub.box_height}</td>
                                <td>{sub.box_weight}</td>
                                <td>{sub.quantity}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> : ""}

                {state.shipmentDetail.carrier_type == "B2B" ?
                  <div class="card border-0 mb-3">
                    <div class="card-body">
                      <div class="d-flex ">
                        <div class="border-end pe-3">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="shopping-basket" class="lucide lucide-shopping-basket"><path d="m15 11-1 9"></path><path d="m19 11-4-7"></path><path d="M2 11h20"></path><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path><path d="M4.5 15.5h15"></path><path d="m5 11 4-7"></path><path d="m9 11 1 9"></path></svg>
                        </div>
                        <div class="ps-3 ">
                          <h6>Invoices Details</h6>
                        </div>
                      </div>
                      <hr />
                      <div class="table-responsive ">
                        <table class="table ">
                          <thead>
                            <tr>
                              <th>Invoice Number</th>
                              <th>Invoice Amount</th>
                              <th>Invoice EBN</th>
                              {/* <th>Total</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {state.shipmentDetail.invoices.map((sub) => (
                              <tr>

                                <td>{sub.invoice_number}</td>
                                <td>{sub.invoice_amount}</td>
                                <td>{sub.invoice_ebn}</td>
                                {/* <td> {bookorder.invoices.reduce((total, sub) => total + parseFloat(sub.invoice_amount), 0).toFixed(2)}</td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> : ""}
                <div class="card border-0 mb-3">
                  <div class="card-body">
                    <div class="d-flex ">
                      <div class="border-end pe-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="shopping-basket" class="lucide lucide-shopping-basket"><path d="m5 11 4-7"></path><path d="m19 11-4-7"></path><path d="M2 11h20"></path><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8c.9 0 1.8-.7 2-1.6l1.7-7.4"></path><path d="m9 11 1 9"></path><path d="M4.5 15.5h15"></path><path d="m15 11-1 9"></path></svg>
                      </div>
                      <div class="ps-3 ">
                        <h6>Product Details</h6>
                      </div>
                    </div>
                    <hr />
                    <div class="table-responsive ">
                      <table class="table">
                        <thead>
                          <tr>
                            <th style={{ width: "20px" }}>Name</th>
                            <th>Category</th>
                            <th>HSN</th>
                            <th>SKU</th>
                            <th>Qty</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                        {state.shipmentDetail.items.map((item) =>
                          <tr>
                            
                              

                                <td style={{ width: "200px" }}>{item.item_name}</td>
                                <td>----</td>
                                <td>----</td>
                                <td>----</td>
                                <td>{item.item_quantity}</td>
                                <td>{item.item_value}</td>

                             
                          </tr>
                           )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>




              </div>
              <div class="col-12 col-md-4">
                <section class="bg-white p-3 mb-3">
                  <p>
                    {state.shipmentDetail.sender.city} <i class="fa fa-long-arrow-right" aria-hidden="true"></i> {state.shipmentDetail.receiver.city}
                    {/* <span class="text-end"><small class="text-muted">Location last updated on 3 May 2022 09:38</small></span> */}
                  </p>


                  {/* <p>Delivery ETA - <span class="text-muted">03-02-2022 @ 23:29</span></p> */}
                </section>
                <div class="card border-0 shadow-sm tracking_xb">
                  <div class="card-body">
                    <div class="d-flex ">
                      <div class="border-end pe-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-search" class="lucide lucide-package-search"><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"></path><path d="m7.5 4.27 9 5.15"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><line x1="12" x2="12" y1="22" y2="12"></line><circle cx="18.5" cy="15.5" r="2.5"></circle><path d="M20.27 17.27 22 19"></path></svg>
                      </div>
                      <div class="ps-3 ">
                        <h6>Tracking Info</h6>
                      </div>
                    </div>
                    <hr />
                    {trackingstate.track != '' && stateship.shipmentDetail != '' ?
                      <div class="progress-container  position-relative">
                        {trackingstate.isLoading == false ?
                          trackingstate.track.history.length > 0 ?
                            trackingstate.track.history.map((sub) => (
                              <div class="step-container">
                                <div class="step active">
                                  <i class="material-icons-outlined">radio_button_checked</i>
                                </div>
                                <div class="progress"></div>
                                <div class="step-info">
                                  <h4>{sub.message} </h4>
                                  <p>{sub.location}</p>
                                  {stateship.shipmentDetail[0].carrier_id=="1744278194"?<p>{sub.time}</p>:
                                  <p>
                                    <Moment format="MMM DD YYYY hh:mm:ss a">
                                    {(sub.time)}
                                  </Moment>
                                  </p>}
                                </div>
                              </div>
                            )) : "No Data Available" : <ReactLoading type="bubbles" color="#0d6efd" style={{ position: 'absolute', right: '45%', height: '20px', width: '10%' }} />}

                      </div> : "No Data Available"}
                    {/* :<ReactLoading type="bubbles" color="#0d6efd" style={{ position: 'absolute', right: '45%', height: '20px', width: '10%' }} />} 
                    */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>





      </section>


      {/* <?php
include('footer.php');
?>   */}

    </div>

  )
}

export default Shipment_detail